import React, { useContext } from 'react'
import config from 'constants/config'
import { Helmet } from 'react-helmet-async'
import GeoContext from 'contexts/geoContext'
import { OFFER_TYPE_BUNDLE_AND_SAVE } from 'constants/offer'

interface Props {
  offer: App.Offer
  availableForPurchase: boolean
}

function OfferGoogleProductDataScript(props: Props) {
  const { offer, availableForPurchase } = props
  const { currentCurrency, currentRegionCode } = useContext(GeoContext)

  const structured_data = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: offer.name,
    image: [] as Array<any>,
    description: offer.description,
    brand: {
      '@type': 'Brand',
      name: config.title,
    },
    offers: {
      '@type': 'AggregateOffer',
      url: `${config.SCHEME}://${config.CUSTOMER_PORTAL_HOST}/${currentRegionCode.toLowerCase()}/offer/${offer.slug}/${offer.id}`,
      priceCurrency: currentCurrency,
      lowPrice: offer.type === OFFER_TYPE_BUNDLE_AND_SAVE ? offer.lowestPriceBundlePackage?.price : offer.lowestPricePackage?.price,
      availability: (availableForPurchase ? 'https://schema.org/LimitedAvailability' : 'https://schema.org/SoldOut'),
      sku: offer.id,
    },
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structured_data)}
      </script>
    </Helmet>
  )
}

export default React.memo(OfferGoogleProductDataScript)
